import { FormType } from '../../../../form-types';
import { SlendidWeightlossFieldAnswers } from '../questions';

export const slendidWlusInitial: FormType<SlendidWeightlossFieldAnswers> = {
  name: 'Weightloss Intake Form',

  questions: [
    {
      key: 'wlus_genderIdentify',
      next: {
        condition: {
          'wlus_genderIdentify.wlus_genderIdentify_male': true
        },
        key: 'slendidWlus_MedicalConditions',
        els: 'wlus_pregnantOrBreastfeedingOrPlanningTo'
      }
    },
    {
      key: 'wlus_pregnantOrBreastfeedingOrPlanningTo',
      next: {
        condition: {
          'wlus_pregnantOrBreastfeedingOrPlanningTo.wlus_PregnantOrBreastfeedingOrPlanningTo_yes':
            true
        },
        key: 'wlus_ineligible',
        els: 'wlus_consentPregnancy'
      }
    },
    {
      key: 'wlus_consentPregnancy',
      next: {
        condition: {
          'wlus_consentPregnancy.wlus_consentPregnancy_non_consent': true
        },
        key: 'wlus_didNotConsent',
        els: 'slendidWlus_MedicalConditions'
      }
    },
    {
      key: 'slendidWlus_MedicalConditions',
      next: {
        switch: [
          {
            condition: {
              'slendidWlus_MedicalConditions.noneOfTheAbove': true
            },
            key: 'wlus_hadAGastricBypassInThePast6Months'
          },
          {
            condition: {
              'slendidWlus_MedicalConditions.gastroparesis': true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'slendidWlus_MedicalConditions.triglyceridesOver600AtAnyPoint':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'slendidWlus_MedicalConditions.pancreaticCancer': true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'slendidWlus_MedicalConditions.pancreatitis': true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'slendidWlus_MedicalConditions.type1Diabetes': true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'slendidWlus_MedicalConditions.hypoglycemia': true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'slendidWlus_MedicalConditions.insulinDependentDiabetes': true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'slendidWlus_MedicalConditions.thyroidCancer': true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'slendidWlus_MedicalConditions.familyHistoryOfThyroidCancer': true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'slendidWlus_MedicalConditions.familyHistoryOfMultipleEndocrineNeoplasiaMEN2Syndrome':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'slendidWlus_MedicalConditions.anorexiaOrBulimia': true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'slendidWlus_MedicalConditions.currentSymptomaticGallstones': true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'slendidWlus_MedicalConditions.gallbladderRemoved': true
            },
            key: 'wlus_consentGallbladder'
          }
        ],
        els: 'wlus_hadAGastricBypassInThePast6Months'
      }
    },
    {
      key: 'wlus_consentGallbladder',
      next: {
        condition: {
          'wlus_consentGallbladder.wlus_consentGallbladder_consent': true
        },
        key: 'wlus_tellUsMoreAboutAboutYourMedicalConditions',
        els: 'wlus_ineligible'
      }
    },
    'wlus_tellUsMoreAboutAboutYourMedicalConditions',

    {
      key: 'wlus_hadAGastricBypassInThePast6Months',
      next: {
        condition: {
          'wlus_hadAGastricBypassInThePast6Months.wlus_hadAGastricBypassInThePast6Months_yes':
            true
        },
        key: 'wlus_ineligible',
        els: 'wlus_weightAndHeight2025'
      }
    },
    'wlus_weightAndHeight2025',
    {
      key: 'wlus_consentBmi',
      next: {
        condition: {
          'wlus_consentBmi.wlus_consentBmi_consent': true
        },
        key: 'wlus_allergicToAnyOfTheFollowing',
        els: 'wlus_ineligible'
      }
    },

    {
      key: 'wlus_allergicToAnyOfTheFollowing',
      next: {
        condition: {
          'wlus_allergicToAnyOfTheFollowing.wlus_allergicToAnyOfTheFollowing_noneOfTheAbove':
            true
        },
        key: 'wlus_doYouTakeAnyOfTheFollowingMedications',
        els: 'wlus_ineligible'
      }
    },
    {
      key: 'wlus_doYouTakeAnyOfTheFollowingMedications',
      next: {
        condition: {
          'wlus_doYouTakeAnyOfTheFollowingMedications.wlus_doYouTakeAnyOfTheFollowingMedications_yes':
            true
        },
        key: 'wlus_ineligible',
        els: 'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications'
      }
    },
    {
      key: 'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications',
      next: {
        switch: [
          {
            condition: {
              'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications.wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications_semiglutide':
                true
            },
            key: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose'
          },
          {
            condition: {
              'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications.wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications_tirzepatide':
                true
            },
            key: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose'
          }
        ],

        els: 'wlus_individualizedConsent'
      }
    },

    /////////////////////////////////////////////
    /////////////////////////////////////////////
    /////// NEW PATIENT SECTION START ///////////
    /////////////////////////////////////////////
    /////////////////////////////////////////////

    /////////////////////////////////////////////
    /////////////////////////////////////////////
    ////////// NEW PATIENT SECTION END //////////
    /////////////////////////////////////////////
    /////////////////////////////////////////////

    /////////////////////////////////////////////
    /////////////////////////////////////////////
    /// START “PATIENTS ALREADY ON TREATMENT” ///
    /////////////////////////////////////////////
    /////////////////////////////////////////////

    'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose',
    'wlus_sideEffects',

    {
      key: 'wlus_MedicationResults',
      next: {
        switch: [
          {
            condition: {
              'wlus_MedicationResults.notLosing_noSideEffects': true
            },
            key: 'wlus_sharedDecisionMakingFast'
          },
          {
            condition: {
              'wlus_MedicationResults.notLosing_andSideEffects': true
            },
            key: 'wlus_sharedDecisionMakingSlow'
          }
        ],
        els: 'wlus_howWouldYouLikeToContinueYourTreatment'
      }
    },
    {
      key: 'wlus_sharedDecisionMakingFast',
      next: {
        key: 'wlus_howWouldYouLikeToContinueYourTreatment'
      }
    },
    'wlus_sharedDecisionMakingSlow',
    'wlus_howWouldYouLikeToContinueYourTreatment',

    /////////////////////////////////////////////
    /////////////////////////////////////////////
    /// END “PATIENTS ALREADY ON TREATMENT” ///
    /////////////////////////////////////////////
    /////////////////////////////////////////////
    {
      key: 'wlus_individualizedConsent',
      next: {
        condition: {
          'wlus_individualizedConsent.consent': true
        },
        key: 'wlus_consentTruthfulness',
        els: 'wlus_didNotConsent'
      }
    },

    {
      key: 'wlus_consentTruthfulness',
      next: {
        condition: {
          'wlus_consentTruthfulness.wlus_consentTruthfulness_consent': true
        },
        key: 'wlus_consentGLP1GIP',
        els: 'wlus_didNotConsent'
      }
    },
    {
      key: 'wlus_consentGLP1GIP',
      next: {
        condition: {
          'wlus_consentGLP1GIP.wlus_consentGLP1GIP_non_consent': true
        },

        key: 'wlus_didNotConsent',
        els: 'wlus_complete'
      }
    },
    'wlus_ineligible',
    'wlus_didNotConsent',
    'wlus_complete'
  ]
};
